module.exports = __webpack_public_path__ + "static/media/smartmirror-main.2b1f320e.png";